import { TargetAudience } from './mentoring-programs';

export enum CustomCommunicationMessageType {
  WELCOME_MESSAGE = 'welcome_message',
  PROFILE_COMPLETION_REMINDER = 'profile_completion_reminder',
  MATCH_ANNOUNCEMENT = 'match_announcement',
};

export type MentorshipProgramCustomCommunication = {
  id: number;
  mentorshipProgramId: number;
  type: CustomCommunicationMessageType;
  subject: string;
  body: string;
  target: TargetAudience;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
};
